import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4_679)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4_679",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M39.167 0.833008V39.167H0.833008V0.833008H39.167Z",
				fill: "white",
				stroke: "white",
				strokeWidth: 1.66667
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4_679)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M37.8855 29.5521C38.1721 29.2654 38.3331 28.8767 38.3331 28.4714C38.3331 28.0661 38.1721 27.6774 37.8855 27.3907L23.3642 12.8694C23.0776 12.5828 22.6888 12.4218 22.2835 12.4218C21.8782 12.4218 21.4895 12.5828 21.2028 12.8694L14.6407 19.4315L4.25722 9.04798C3.96893 8.76954 3.58281 8.61547 3.18203 8.61896C2.78124 8.62244 2.39786 8.7832 2.11445 9.0666C1.83105 9.35001 1.67029 9.73339 1.66681 10.1342C1.66332 10.535 1.81739 10.9211 2.09583 11.2094L13.56 22.6736C13.8467 22.9601 14.2354 23.1211 14.6407 23.1211C15.046 23.1211 15.4348 22.9601 15.7214 22.6736L22.2835 16.1115L35.7242 29.5521C36.0108 29.8387 36.3995 29.9996 36.8049 29.9996C37.2102 29.9996 37.5989 29.8387 37.8855 29.5521Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M26.105 28.4714C26.105 28.8768 26.266 29.2656 26.5527 29.5523C26.8393 29.839 27.2281 30 27.6335 30H36.8049C37.2103 30 37.5991 29.839 37.8858 29.5523C38.1724 29.2656 38.3335 28.8768 38.3335 28.4714V19.3001C38.3335 18.8947 38.1724 18.5059 37.8858 18.2192C37.5991 17.9326 37.2103 17.7715 36.8049 17.7715C36.3995 17.7715 36.0107 17.9326 35.724 18.2192C35.4374 18.5059 35.2763 18.8947 35.2763 19.3001V26.9429H27.6335C27.2281 26.9429 26.8393 27.1039 26.5527 27.3906C26.266 27.6772 26.105 28.066 26.105 28.4714Z",
				fill: "currentColor"
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4_679",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgChartDown;
